import { useMemo, useState } from 'react'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'
import { errorHandler } from '../../../../services/util/error.service'
import * as PickingHttp from '../../../../services/api/https/picking/picking.http'

const INITIAL_STATE = {
  loadingMessage: null,
  errorMessage: null,
  modalOpcoesIsVisible: false,
}

export default function usePickingMaisOpcoes() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    return {
      async exportarPicking(picking) {
        try {
          const { id, status } = picking

          if (status !== 'Pronto Para Download' && status !== 'Resumo Emitido') {
            setState(prevState => ({
              ...prevState,
              errorMessage:
                'Somente os pickings com status "Pronto para Download" ou "Resumo Emitido" podem ser exportados',
            }))
          } else {
            setState(prevState => ({
              ...prevState,
              loadingMessage: 'Exportando as informações do Picking',
            }))
            const data = await PickingHttp.exportarPicking(id)
            if (data.length <= 1) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'Não existem dados para exportação',
                loadingMessage: null,
              }))
            } else {
              const rows = [
                [
                  'Código',
                  'Separação',
                  'Identificador',
                  'Cliente',
                  'Area',
                  'AreaApelido',
                  'Equipe',
                  'Cod Produto',
                  'Produto',
                  'Quantidade',
                  'Código Etiqueta',
                ],
              ]

              data.forEach(d => {
                const {
                  codigo_separacao,
                  separacao,
                  identifier,
                  nomeFantasia,
                  area,
                  area_nickname,
                  equipe,
                  product_code,
                  produto,
                  qte_total,
                  codigo_etiqueta,
                } = d
                rows.push([
                  codigo_separacao,
                  separacao,
                  identifier,
                  nomeFantasia,
                  area,
                  area_nickname,
                  equipe,
                  product_code,
                  produto,
                  qte_total,
                  codigo_etiqueta,
                ])
              })
              gerarArquivoExcel('separacao', rows, `picking_${rows[1][0]}.xlsx`)
              setState(prevState => ({
                ...prevState,
                errorMessage: null,
                loadingMessage: null,
              }))
            }
          }
        } catch (error) {
          setState(prevState => ({
            ...prevState,
            errorMessage: errorHandler(error),
            loadingMessage: null,
          }))
        }
      },

      openFormularioReconferencia(picking) {
        const { status } = picking
        if (status !== 'Resumo Emitido') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'O Picking precisa estar com o status "Resumo Emitido"',
          }))
        } else {
          PickingHttp.openFormularioReconferencia(picking)
        }
      },

      openResumoSeparacaoAnalitico(picking) {
        const { status } = picking
        if (status !== 'Resumo Emitido') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'O Picking precisa estar com o status "Resumo Emitido"',
          }))
        } else {
          PickingHttp.openResumoSeparacaoAnalitico(picking)
        }
      },

      openResumoSeparacaoPorOrigemPDF(picking) {
        const { status } = picking
        if (status !== 'Resumo Emitido') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'O Picking precisa estar com o status "Resumo Emitido"',
          }))
        } else {
          PickingHttp.openResumoSeparacaoPorOrigemPDF(picking)
        }
      },

      openResumoSeparacaoPorOrigemEXCEL(picking) {
        const { status } = picking
        if (status !== 'Resumo Emitido') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'O Picking precisa estar com o status "Resumo Emitido"',
          }))
        } else {
          PickingHttp.openResumoSeparacaoPorOrigemEXCEL(picking)
        }
      },

      openListagemDeProdutosConferidosPDF(picking) {
        const { status } = picking
        if (status !== 'Resumo Emitido') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'O Picking precisa estar com o status "Resumo Emitido"',
          }))
        } else {
          PickingHttp.openListagemDeProdutosConferidosPDF(picking)
        }
      },

      openRelacaoPosicoesEstoquePalletArea(picking) {
        PickingHttp.openRelacaoPosicoesEstoquePalletArea(picking)
      },

      openFichaRecebimentoCarga(picking) {
        const { status } = picking
        if (status !== 'Resumo Emitido') {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'O Picking precisa estar com o status "Resumo Emitido"',
          }))
        } else {
          PickingHttp.openFichaRecebimentoCarga(picking)
        }
      },

      openComparativoPickingLoteValidade(picking) {
        const { status } = picking
        const allowedStatuses = ['Pronto Para Download', 'Picking Concluido', 'Resumo Emitido']
        if (!allowedStatuses.includes(status)) {
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Este relatório não está disponível no status atual deste picking',
          }))
        } else {
          PickingHttp.openComparativoPickingLoteValidade(picking)
        }
      },

      openModalOpcoesDownload() {},

      closeModal() {
        setState(prevState => ({ ...prevState, modalOpcoesIsVisible: false }))
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          errorMessage: null,
          loadingMessage: null,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
